import { BernieGraphqlClient, FetchPolicy, RequestOptions } from 'bernie-graphql';
import * as generated from './types';
import * as operations from './operations';

export interface OperationResult<T> {
  data: T;
  errors?: [];
  extensions: any;
  headers: Headers;
}

function isFetchPolicy(requestOptions: RequestOptions | FetchPolicy): requestOptions is FetchPolicy {
      return typeof requestOptions === 'string';
}

export class ApiOperations {
    public constructor(private client: BernieGraphqlClient) {
      //
    }

    public flightsFlexibleSearch(
      variables: generated.FlightsFlexibleSearch.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsFlexibleSearch.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsFlexibleSearchQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsFlexibleSearch.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsFlexibleDiscoverySearch(
      variables: generated.FlightsFlexibleDiscoverySearch.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsFlexibleDiscoverySearch.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsFlexibleDiscoverySearchQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsFlexibleDiscoverySearch.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightInformationResults(
      variables: generated.FlightsShoppingPwaFlightInformationResults.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightInformationResults.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightInformationResultsQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightInformationResults.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightInformationResultsLoading(
      variables: generated.FlightsShoppingPwaFlightInformationResultsLoading.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightInformationResultsLoading.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightInformationResultsLoadingQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightInformationResultsLoading.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaSeatSelection(
      variables: generated.FlightsShoppingPwaSeatSelection.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaSeatSelection.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaSeatSelectionQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaSeatSelection.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightServicingResults(
      variables: generated.FlightsShoppingPwaFlightServicingResults.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightServicingResults.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightServicingResultsQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightServicingResults.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightServicingConfirmationResults(
      variables: generated.FlightsShoppingPwaFlightServicingConfirmationResults.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightServicingConfirmationResults.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightServicingConfirmationResultsQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightServicingConfirmationResults.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsSearchMetadata(
      variables: generated.FlightsSearchMetadata.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsSearchMetadata.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsSearchMetadataQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsSearchMetadata.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public initiateMultiItemSession(
      variables: generated.InitiateMultiItemSession.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.InitiateMultiItemSession.Mutation>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .mutate(
          {
            mutation: operations.initiateMultiItemSessionQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.InitiateMultiItemSession.Mutation;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchFormLoaded(
      variables: generated.FlightsShoppingPwaFlightSearchFormLoaded.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchFormLoaded.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchFormLoadedQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchFormLoaded.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchFormLoading(
      variables: generated.FlightsShoppingPwaFlightSearchFormLoading.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchFormLoading.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchFormLoadingQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchFormLoading.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchResultsFlightsSearch(
      variables: generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchResultsFlightsSearchQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchResultsFlightsSearch.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchResultsGreedyFetchLoading(
      variables: generated.FlightsShoppingPwaFlightSearchResultsGreedyFetchLoading.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchResultsGreedyFetchLoading.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchResultsGreedyFetchLoadingQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchResultsGreedyFetchLoading.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchResultsLoadingFlightsSearch(
      variables: generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchResultsLoadingFlightsSearchQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightSearchResultsOnClientLoading(
      variables: generated.FlightSearchResultsOnClientLoading.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightSearchResultsOnClientLoading.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightSearchResultsOnClientLoadingQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightSearchResultsOnClientLoading.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public flightsShoppingPwaFlightSearchUpsellResultsFlightsSearch(
      variables: generated.FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearch.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearch.Query>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .query(
          {
            query: operations.flightsShoppingPwaFlightSearchUpsellResultsFlightsSearchQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.FlightsShoppingPwaFlightSearchUpsellResultsFlightsSearch.Query;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public selectPackage(
      variables: generated.SelectPackage.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.SelectPackage.Mutation>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .mutate(
          {
            mutation: operations.selectPackageQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.SelectPackage.Mutation;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public selectProducts(
      variables: generated.SelectProducts.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.SelectProducts.Mutation>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .mutate(
          {
            mutation: operations.selectProductsQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.SelectProducts.Mutation;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public virtualAgentFlightCheckout(
      variables: generated.VirtualAgentFlightCheckout.Variables,
      options?: FetchPolicy | RequestOptions
    ): Promise<OperationResult<generated.VirtualAgentFlightCheckout.Mutation>> {
      let requestOptions: RequestOptions;
      let fetchPolicy: FetchPolicy;

      if(options){
        requestOptions = isFetchPolicy(options) ? null : options;
        fetchPolicy = isFetchPolicy(options) ? options : requestOptions.fetchPolicy;
      }

      return this.client
        .mutate(
          {
            mutation: operations.virtualAgentFlightCheckoutQuery,
            variables,
            fetchPolicy
          },
          requestOptions
        )
          .then(result => {
            const body = result.body;
            const data = body.data as generated.VirtualAgentFlightCheckout.Mutation;
            const extensions = body.extensions;
            const errors = body.errors;
            const headers = result.headers;

            return { data, errors, extensions, headers };
          });
    }

    public static withClient(client: BernieGraphqlClient) {
      return new ApiOperations(client);
    }
}
